import FeaturedArtworks from './FeaturedArtworks';

export default FeaturedArtworks;
